import {
  useDeviceSize,
  Breakpoint,
} from '@grubhubprod/umami-library/dist/hooks/useDeviceSize';
import { Flex } from '@grubhubprod/gh-cookbook-react/dist';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { getWindow } from 'src/utilities/window';
import { SignupStep } from 'src/components/selfService/features/Signup/context/SignupStatusProvider/SignupStatusProvider';
import { ProgressTrackerSteps } from 'src/components/common/features/Signup/components/SignupProgressTracker/ProgressTrackerSteps/ProgressTrackerSteps';
import { IEnterpriseSignupStep } from 'src/components/EnterpriseSignupStatusProvider/EnterpriseSignupStatusProvider';

export interface ISignupStep {
  name: string;
  id: SignupStep;
  content?: JSX.Element;
}

export interface ISignupProgressTracker {
  steps: ISignupStep[] | IEnterpriseSignupStep[];
  isInWelcomeModal?: boolean;
  isEnterprise?: boolean;
}

const DESKTOP_HEIGHT = '352px';
const DESKTOP_WIDTH = '138px';

export function SignupProgressTracker({
  steps,
  isInWelcomeModal,
  isEnterprise,
}: ISignupProgressTracker): JSX.Element {
  const { breakpoint } = useDeviceSize(getWindow());
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const isPhone = breakpoint < Breakpoint.sm;

  return (
    <Flex
      as="ol"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent={isPhone ? 'stretch' : 'space-between'}
      height={isPhone || isInWelcomeModal ? 'auto' : DESKTOP_HEIGHT}
      width={isPhone || isInWelcomeModal ? '100%' : DESKTOP_WIDTH}
      padding={isPhone || isInWelcomeModal ? '4px 0 0 12px' : '0'}
      className={classnames('signupProgressTrackerContainer', {
        mounted: isMounted,
      })}
    >
      <ProgressTrackerSteps
        isEnterprise={isEnterprise}
        steps={steps}
        isInWelcomeModal={isInWelcomeModal}
      />
    </Flex>
  );
}
